module.exports = __webpack_public_path__ + "static/media/loyalty.d7e915da.png";